import {useVersionsContext} from "../../../../Context/versions-context";
import Alert from "@material-ui/lab/Alert";
import {DataCell, ModuleTable} from "../../../Utils/Lists/CollapsibleList";
import TableRow from "@material-ui/core/TableRow";
import {AutoCompleteProducts} from "../../../Utils/FormInputs/AutoCompleteInput";
import TextField from "../../../Utils/FormInputs/TextField";
import {ErrorMessage, RightAlignedContainer} from "../../../Utils/styledComponents";
import {StyledCell} from "../../../DoctorsModule/doctorStyles";
import Form from "react-bootstrap/Form";
import {titleCase} from "../../../Users/addUser";
import React, {useEffect, useState} from "react";
import {CommonTableData, SundriesData} from "../../../DoctorsModule/Prescription/NewPrescription";
import {useSundries} from "../../../DoctorsModule/Prescription/hooks/useSundries";
import axios from "axios";
import {config} from "../../../../Helpers/env";
import {v4 as uuidv4} from "uuid";
import {errorMessages} from "../../../../Helpers/ErrorMessages";
import {history} from "../../../../Helpers/history";
import {BlockNavigationComponent} from "../../../Utils/ReusableComponents/BlockNavigationComponent";
import {ConfirmationDialog} from "../../../Utils/ReusableComponents/ConfirmationDialog";
import {filteredPrescriptionArr} from "./GynPreviousPrescription";

export const NewPrescriptionRequest = ({actions, visit_id,isSubmitted, setIsSubmitted, setOpenDialog,
                                  isBlocking, setIsBlocking,isBlockDialog, setIsBlockDialog, prescription_id=null}) =>{

    const user = JSON.parse(sessionStorage.getItem('user'));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const user_roles_id = !_token.user_roles_id ? 1 : _token.user_roles_id;

    const initialPrescState = [{
        drug_name: '', dosage: '', disabled: false,generic_name:'', stock:'',
        number_of_days: 0, key_information: '', rate: 0, date: '', invoice_no: '',
        product_id: '', showDrug: false,  frequency: '', isError: false,
        prescription_detial_id: '', bill_id: '', isEdited: false, status:0,currency:'',
        currency_symbol:'', uuid : uuidv4(), quantity_to_bill:''
    }]
    const initialOthers = [{
        other_medicine: '', dosage: '', disabled: false, quantity:0,
        number_of_days: 0, key_information: '', frequency: '', rate: 0
    }]
    const [submitted, setSubmitted] = useState(false);
    const [prescription, setPrescription] = useState(initialPrescState);
    const [others, setOthers] = useState(initialOthers);
    const [drugs, setDrugs] = useState([]);
    const [other, setOther] = useState(false);
    const [openConfirmation, setOpenConfirmation] = useState(false)
    const [product_id, setProductId] = useState('')
    const [alert, setAlert] = useState({open:false, message:'', isExpired:false})
    const [isSundries, setIsSundries] = useState(false);
    const obj = {actions, visit_id,setIsBlocking}
    const {sundryProps} = useSundries(obj);
    const {sundries, setSundries, initialState, handleResetSundries, openSundries,
    handleCancelSundries, handleCloseSundries, addSundriesToReceipt} = sundryProps;

    const isDrugClicked = isSubmitted === 'clickedDrug';


    useEffect(() => {
        setIsSubmitted('idle');
    }, [isDrugClicked]);


    const retrieveDrugs = (eventTxt, idx) => {
        const arr = prescription.map((item, index) => {
            if (index === idx) {
                const formData = new FormData();
                formData.append('product_name', titleCase(eventTxt));
                if (eventTxt !== '') {
                    axios.post(`${config.smsUrl}/cdoctor/autocomplete_search_medicine`, formData).then(res => {
                        const resp = res.data;
                        const data = !resp ? [] : resp;
                        if (data[0] === "No Product Found") {
                            setDrugs([{value: '', label: 'No medicine found'}])
                        } else {
                            const arr = data.map(item=>({value:item.value, label: `${item.label}-${item.generic_name}-${item.country_of_origin}`}))
                            setDrugs(arr);
                        }
                    }).catch(error => {
                        // logoutErrorMessage(error, null, actions)
                    });
                    return {...item, drug_name: eventTxt, showDrug: true, isError: false, }
                }
                return {...item, drug_name: eventTxt, showDrug: false, isError: false}
            }
            return item
        })
        setAlert({...alert, open: false})
        setPrescription(arr)
        setIsSubmitted('idle')
        setIsBlocking(true)
    };

    const clickDrug = (event, idx) => {
        let arr = prescription.map((item, index)=>{
            if (index === idx){
                return {...item, drug_name:event.innerText, product_id:event.value, generic_name:event.generic_name,
                    isError: false, showDrug: false}
            }
            return item
        })
        const formData = new FormData();
        formData.append('product_id', event.value);
        formData.append('location', 2); // 2 for pharmacy
        formData.append('to_store', 'Pharmacy');
        if (event.value) {
            axios.post(`${config.smsUrl}/cdoctor/get_medicinedetails_byproduct_id`, formData).then(res => {
                const resp = res.data;
                const data = !resp ? {} : resp;
                const {quantity} = data
                setAlert({...alert, open: data.isExpired, message: event.innerText, isExpired: data.isExpired})
                axios.post(`${config.smsUrl}/cbilling/item_cost`, {visit_id: +visit_id, item_id:+event.value, item_type:'product'}).then(res => {
                    const resObj = res.data;
                    const dataObj = !resObj.data ? {} : resObj.data;
                    arr = arr.map((item, index)=>{
                        if (index === idx){
                            return {...item, rate:  dataObj.cost ?? 0,status: quantity,...dataObj,isExpired:data.isExpired,
                                currency: dataObj.currency_id, currency_symbol: dataObj.currency, stock:quantity,
                                quantity_to_bill:+dataObj.pack_unit, is_provided:dataObj.is_provided, pack_unit:+dataObj.pack_unit}
                        }
                        return item
                    })
                    setPrescription(arr)
                    if(dataObj.is_provider === 1 && dataObj.is_provided === 0){
                        setProductId(event.value)
                        setOpenConfirmation(true)
                    }
                    setIsSubmitted('clickedDrug');
                }).catch(error => {
                    errorMessages(error, null, actions)
                });
            }).catch(error => {
                errorMessages(error, null, actions)
            });
        }
        setIsBlocking(true)
    }

    const handleChangeOther = (event) => {
        setOther(event.target.checked)
        setIsBlocking(true)
    }

    const handleCloseAlert = () =>{
        setAlert({...alert, open: false})
    }

    const addItemsToReceipt = () =>{
        const arr = prescription.filter(item=>item.product_id === product_id)
        setOpenConfirmation(false)
    }

    const handleCloseConfirmation = () =>{
        const arr = prescription.filter(item=>item.product_id !== product_id)
        setPrescription(arr)
        setOpenConfirmation(false)
    }

    const handleCancelConfirmation = () =>{
        setOpenConfirmation(false)
    }

    const handleChangeItems = (event, index) => {
        const {name, value} = event.target;
        const arr = prescription.map((item, idx) => {
            if (idx === index) {
                return {...item, [name]: value, isEdited: !!item.product_bill_detail_id}
            }
            return item
        })
        setPrescription(arr)
        setIsSubmitted('idle')
        setIsBlocking(true)
    };

    const handleChangeOtherMedicine = (event, index) => {
        const {value, name} = event.target
        const arr = others.map((item, idx) => {
            if (idx === index) {
                return {...item, [name]: value}
            }
            return item
        })
        setOthers(arr)
        setIsSubmitted('idle')
        setIsBlocking(true)
    }

    const handleAddOther = () => {
        setOthers([...others, ...initialOthers])
    }

    const handleRemoveOther = (index) => {
        const arr = others.filter((_, idx) => idx !== index)
        setOthers(arr)
        setIsSubmitted('idle')
    }

    const handleAddRow = () => {
        const filtered_Prescription = prescription.filter(item=>!item.isExpired)
        setPrescription([...filtered_Prescription, ...initialPrescState])
        setAlert({...alert, open: false})
    };

    const removeRow = (item_uuid) => {
        const arr = prescription.filter((e) => e.uuid !== item_uuid)
        setPrescription(arr);
        setAlert({...alert, open: false})
    }

    const handleToggleSundries = (e) => {
        setIsSundries(e.target.checked)
        setIsBlocking(true)

    }

    const handleResetForm = () =>{
        setOpenDialog(false)
        setIsBlockDialog(false)
        setIsBlocking(false)
        setSubmitted(false);
        setOther(false)
        setIsSundries(false)
        const resetProducts = prescription.map(item=>({
            ...item, drug_name: '', dosage: '', disabled: false,generic_name:'', stock:'',
            number_of_days: 0, key_information: '', rate: 0, date: '', invoice_no: '',
            product_id: '', showDrug: false,  frequency: '', isError: false,
            prescription_detial_id: '', bill_id: '', isEdited: false, status:0,currency:'',
            currency_symbol:'', uuid : ''
        }))
        setPrescription(resetProducts)

        const resetOthers = others.map(item=>({
            ...item, other_medicine: '', dosage: '', disabled: false, quantity:0,
            number_of_days: 0, key_information: '', frequency: '', rate: 0
        }))
        setIsSundries(false)

        setOther(false)

        setOthers(resetOthers)

        handleResetSundries()
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        setSubmitted(true);
        const arr = prescription.every(item => ((item.product_id && item.quantity && item.quantity > 0 && item.quantity <= item.stock && !item.isExpired) || (other && (!item.product_id && item.quantity && item.other_medicine))))
        const isSundry = sundries.every(item => item.product_name) ;

        const sunArr = isSundries ? (arr && isSundry) : arr;
        const onlySunArr = (isSundries && !arr) ? isSundry : false;
        setIsBlocking(false)
        if (sunArr || onlySunArr) {
            setIsSubmitted('pending');
            const editObj = prescription_id ? {
                prescription_id,
                invoices_edited:[],
                invoices_removed:[]
            } : null
            const params = {
                bill_type: 3,
                ...editObj,
                products: prescription_id ? filteredPrescriptionArr(prescription.filter(item=>Boolean(item)).filter(drug => drug.product_id && !drug.isExpired)) :
                prescription.filter(item=>Boolean(item)).filter(drug => drug.product_id && !drug.isExpired).map(presc => ({
                    dosage: presc.dosage,
                    number_of_days: +presc.number_of_days,
                    key_information: presc.key_information,
                    rate: presc.rate,
                    product_id: presc.product_id,
                    frequency: presc.frequency,
                    quantity_prescribed:parseInt(presc.quantity),
                    is_provided: presc.is_provided,
                    is_provider: presc.is_provider,
                    currency_id:presc.currency_id,
                    quantity_billable:presc.quantity_billable,
                    quantity_to_bill: +presc.quantity_to_bill

                })),
                sundries: sundries.filter(item=>Boolean(item)).filter(item=>item.product_id).map(item=>({
                    bill_type:3,
                    ...item
                }))
            }
            const url = prescription_id ? 'update_prescription' : 'save_prescription'
            axios.post(`${config.smsUrl}/cdoctor/${url}`, {
                visit_id, user_roles_id,
                other_products: others.filter(item=>Boolean(item)).filter(drug => drug.other_medicine || drug.dosage || drug.price || drug.instructions ||
                    drug.frequency || drug.number_of_days), ...params
            }).then(res => {
                const data = res.data;
                const dt = !data ? {} : data;
                const presc_id = !dt.prescription_id ? "" : dt.prescription_id;
                actions.snackbarActions.snackSuccess(`Prescription added successfully`);
                setIsSubmitted('resolved');
                handleResetForm()
            }).catch(err => {
                setIsSubmitted('rejected');
                errorMessages(err, null, actions);

            })
        }

    };


    const isPending = isSubmitted === 'pending';
    const isResolved = isSubmitted === 'resolved';


    const all_drugs = drugs ? drugs : [];
    const sundriesHeadData = [ {item:' Sundry Name'}, {item:'Cost'},{item:'Action'} ];
    const isUUID = true;
    const {subscription} = useVersionsContext()
    const version = subscription?.version
    const isPremium = version === 'Premium'


    const headData = [{item:'Drug Name', toolTip:'Enter drug name', isRequired:true},
        isPremium ? {item:'Quantity to bill',  toolTip:'Enter quantity to bill', isRequired: true, tier:"Premium"}: null,
        {item:'Quantity Prescribed',  toolTip:'Enter Prescribed Quantity'}, {item:'Available Stock'},
        {item:'Dosage',  toolTip:'Enter dosage'}, {item:'Frequency',  toolTip:'Enter frequency'},
        {item:'No. of Days',  toolTip:'Enter number of days'},
        {item:'Instructions',  toolTip:'Enter instructions'}, {item:'Cost'},{item:'Action'}]



    const {open, isExpired, message} = alert
    return (
        <form onSubmit={handleSubmit}>
            <BlockNavigationComponent
                when={isBlocking}
                shouldBlockNavigation={() => {
                    return isBlocking;
                }}
                navigate={(path) => history.push(path)}
                dialogClose={isBlockDialog}
                setIsBlockDialog={setIsBlockDialog}
                clearForm={handleResetForm}
            />
            <ConfirmationDialog
                open={openConfirmation}
                handleClose={handleCancelConfirmation}
                title="Make cash payment"
                confirmItems={addItemsToReceipt}
                removeItems={handleCloseConfirmation}
                service="product"
            />

            <ConfirmationDialog
                open={openSundries}
                handleClose={handleCancelSundries}
                title="Make cash payment"
                confirmItems={addSundriesToReceipt}
                removeItems={handleCloseSundries}
                service="sundry"
            />
            {open && isExpired ? <Alert severity="error" style={{paddingTop: 0, paddingBottom: 0, marginBottom: '8px'}}
                                        onClose={handleCloseAlert}>
                <strong>{message} is expired!</strong> Please choose another drug
            </Alert> : null}
            <ModuleTable headData={headData.filter(item => Boolean(item))}>
                {prescription?.map((item, index) => (
                    <TableRow
                        key={item.uuid}
                    >
                        <DataCell variant='300'>
                            <AutoCompleteProducts reset={isResolved} options={all_drugs} submitted={submitted}
                                                  idx={index} handleChange={retrieveDrugs} label_text="label"
                                                  medicine_value={{
                                                      label: prescription[index].drug_name,
                                                      value: prescription[index].product_id,
                                                      generic_name: prescription[index].generic_name
                                                  }}
                                                  id="drug_name" value_text="value"
                                                  errorMsg_Valid={"Enter valid drug name"}
                                                  valid_error_check={item.isError && submitted}
                                                  testId={`doc_drug_name-${index}`}
                                                  handleProductData={clickDrug} placeholder="Type Product Name"
                                                  errorMsg="Enter Product Name"/>

                        </DataCell>
                        {isPremium ? <DataCell variant='150'>
                            <TextField type="number" disabled={!(item.is_provided && item.pack_unit)}
                                       value={item.quantity_to_bill}
                                       submitted={submitted && item.is_provided && item.pack_unit}
                                       onChange={(e) => handleChangeItems(e, index)} name="quantity_to_bill" required
                                       min={0}/>
                            {submitted && item.is_provided && item.pack_unit && !item.quantity_to_bill ?
                                <ErrorMessage>Quantity to bill is required</ErrorMessage> : null}
                        </DataCell> : null}
                        <DataCell variant='150'>
                            <TextField type="number" disabled={item.isExpired} value={item.quantity}
                                       submitted={submitted}
                                       onChange={(e) => handleChangeItems(e, index)} name="quantity" required min={0}/>
                            {submitted && !item.quantity ? <ErrorMessage>Quantity is required</ErrorMessage> :
                                item.quantity > item.stock ?
                                    <ErrorMessage>Quantity should be less than stock</ErrorMessage> :
                                    item.quantity < 0 ?
                                        <ErrorMessage>Quantity should be more than 0</ErrorMessage> : null}
                        </DataCell>
                        <DataCell variant='100'>
                            {item.stock}
                        </DataCell>
                        <CommonTableData {...{handleChangeItems, removeRow, item, index, isUUID}}/>
                    </TableRow>
                ))}
                <TableRow>
                    <StyledCell colSpan={headData.length}>
                        <button type="button" onClick={handleAddRow} className="btn btn-sm sms-gray-btn"
                                id="add-row">Add another line
                        </button>
                    </StyledCell>
                </TableRow>
                <TableRow>
                    <DataCell>
                        <Form.Check label="Add other drugs" type="checkbox" className="radio-btn mr-4" name="other"
                                    inline
                                    onChange={handleChangeOther} checked={other}/>
                        {!other ? <Form.Check type="checkbox" label='Request sundries' className="radio-btn"
                                              style={{fontSize: '14px'}}
                                              defaultChecked={isSundries} onChange={handleToggleSundries}
                                              inline/> : null}

                    </DataCell>
                </TableRow>
                {other ?
                    <>
                        {others.map((item, index) => (
                            <TableRow
                                key={index}
                            >
                                <DataCell>
                                    <TextField
                                        value={item.other_medicine ? titleCase(item.other_medicine) : item.other_medicine}
                                        type="text"
                                        name="other_medicine" data-testid="doc-product-name"
                                        onChange={(e) => handleChangeOtherMedicine(e, index)}
                                    />
                                    {submitted && !item.other_medicine &&
                                        <ErrorMessage>Quantity is required</ErrorMessage>}
                                </DataCell>
                                <DataCell/>
                                <DataCell>
                                    <TextField type="number" value={item.quantity}
                                               onChange={(e) => handleChangeOtherMedicine(e, index)} name="quantity"/>
                                    {/*submitted && !item.quantity && <ErrorMessage>Quantity is required</ErrorMessage> */}
                                </DataCell>
                                <DataCell/>
                                <CommonTableData {...{
                                    handleChangeItems: handleChangeOtherMedicine,
                                    removeRow: handleRemoveOther,
                                    item,
                                    index
                                }}/>
                            </TableRow>
                        ))}
                        <TableRow>
                            <DataCell colSpan={headData.length}>
                                <button type="button" onClick={handleAddOther} className="btn btn-sm sms-gray-btn"
                                        id="add-row">Add another line
                                </button>
                            </DataCell>
                        </TableRow>
                    </> : null}
                <TableRow>
                    <DataCell>

                        {other ? <Form.Check type="checkbox" label='Request sundries' className="radio-btn"
                                             style={{fontSize: '14px'}}
                                             defaultChecked={isSundries} onChange={handleToggleSundries}
                                             inline/> : null}
                    </DataCell>
                </TableRow>
            </ModuleTable>
            <div className="mt-3">
                {isSundries ?
                    <ModuleTable headData={sundriesHeadData}>
                        <SundriesData {...{...sundryProps, isOutPatient: true}} submitted={submitted}/>
                    </ModuleTable> : null}
            </div>
            <RightAlignedContainer>
                <button
                    type="submit"
                    className="btn sms-btn btn-sm"
                    disabled={isPending}
                >
                    {isPending ? "Saving..." : "Save Prescription"}
                </button>
            </RightAlignedContainer>
        </form>
    )
}